export default {
  apiBaseUrl: 'https://qa-chloe-api.peoplescience.health/api/',
  socketUrl: 'https://qa-chloe-api.peoplescience.health/',
  webUrl: 'https://qa-chloe.peoplescience.health',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  referralUrl: 'https://qa-chloe.peoplescience.health/referrals/',
  fitbitWebClientId: '238QPG',
  fitbitAppClientId: '23RF47',
  oAuthRedirectWebUri: 'https://qa-chloe-app.peoplescience.health/*',
  oAuthRedirectAppUri: 'health.peoplescience.chloe3.qa://MyStudiesScreen',
  ouraAppClientId: 'XSTZWEVOMEFCGDEM',
  googleFitScopes: [
    'https://www.googleapis.com/auth/fitness.sleep.read',
    'https://www.googleapis.com/auth/fitness.activity.read',
    'https://www.googleapis.com/auth/fitness.body.read',
    'https://www.googleapis.com/auth/fitness.nutrition.read',
    'https://www.googleapis.com/auth/fitness.blood_pressure.read',
    'https://www.googleapis.com/auth/fitness.blood_glucose.read',
    'https://www.googleapis.com/auth/fitness.oxygen_saturation.read',
    'https://www.googleapis.com/auth/fitness.body_temperature.read',
    'https://www.googleapis.com/auth/fitness.heart_rate.read'
  ],
  recaptchaSiteKey: '6LciVLYoAAAAAOpCrfDoYbh8dXyxN4ycIW30WDoZ',
  googleTagManagerId: 'GTM-TP4P4FQ'
};
